import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  resultWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    zIndex: 2
  }
})

export default useStyles